<div class="card-header" style="margin-top: 19px; height: 60px">
  <span class="title" style="font-size: 22px; line-height: 45px; vertical-align: middle">EBS Cost Controls</span>

  <button class="btn btn-primary-soft" style="float: right; margin: 0 10px" (click)="refresh()">
    <i class="fa fa-refresh" aria-hidden="true"></i>
    Refresh
  </button>
  <button class="btn btn-success-soft" style="float: right; margin: 0 10px"
    *ngIf="loading_recom == false && recomondations.length > 0 && currentPage == 'recomondations'"
    (click)="downloadReport()"><i class="fa fa-download" aria-hidden="true"></i>
    Download</button>
</div>
<div class="card">
  <!-- <div style="width: 100%; height: 100px; background-color: red;"></div> -->
  <div class="card-body">
    <div style="display: flex; justify-content: flex-start; padding: 10px; align-items: center; gap: 10px;">
      <div>Potential Saving: </div>
      <div>
        <span class="green_text" style="margin-left: 5px; font-size: 1.5em;"
          [innerHTML]="getTotalSavings() + ' USD'"></span>
      </div>
      <div *ngIf="loading_recom">
        <img src="../assets/img/loading_2.svg" alt="loading scans" width="10" style="width: 15px; margin: 10px;">
      </div>
    </div>
    <div style="max-width: 100%; overflow-x: auto;">
      <table class="table table-docs table-hover cost-table" id="ebs_cost_optimization">
        <thead>
          <tr>
            <th>S.N.</th>
            <th *ngFor="let h of ec2CostHeaders">
              {{ h.name }}
              <span *ngIf="h.sort && h.sort.sort" (click)="notifier.sortTable(h, recomondations)">
                <i class="fa fa-sort-amount-desc" aria-hidden="true" *ngIf="h.sort.direction == 'Des'"></i>
                <i class="fa fa-sort-amount-asc" aria-hidden="true" *ngIf="h.sort.direction == 'Asc'"></i>
              </span>

              <span *ngIf="h.filter" class="inputseach">
                <input type="text" [(ngModel)]="h.filterText" />
                <i class="fa fa-search" aria-hidden="true"></i>
              </span>
            </th>
            <th>More Details</th>
            <th>Reason</th>
          </tr>
        </thead>

        <tbody [ngStyle]="{'display': recomondations.length ? 'table-row-group': 'none'}"
          *ngFor="let i of recomondations; let j = index">
          <tr *ngIf="notifier.filterTableColums(ec2CostHeaders, i)">
            <td>{{ j + 1 }}</td>
            <td *ngFor="let h of ec2CostHeaders">
              <div *ngIf="h.click" class="btn" (click)="callFunction(h.click, i)">
                <div [ngStyle]="{'text-align': h.center ? 'center': 'left'}" [innerHTML]="loadHTML(i[h.id])">
                </div>
              </div>
              <div [ngStyle]="{'text-align': h.center ? 'center': 'left'}" *ngIf="!h.click"
                [innerHTML]="loadHTML(i[h.id])">
              </div>
            </td>
            <td>
              <div class="failed_ami" (mouseenter)="setPosition($event)">
                <div class="status_container">
                  <div style="border-bottom: 1px dotted black;">
                    More Details
                  </div>
                </div>
                <div class="failed_ami_message_container"
                  [ngStyle]="{right: position.x ? position.x : 0, top: position.y ? position.y : 0}">
                  <div class="message_back">
                    <div>
                      <div class="message_grid"
                        [ngStyle]="{'max-width': position.overflow ? position.overflowwidth : '', 'overflow-x': position.overflow ? 'auto' : 'visible'}">
                        <table>
                          <thead>
                            <tr>
                              <th *ngFor="let h of moreDetailsHeaders">{{h.name}}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td *ngFor="let h of moreDetailsHeaders">{{i[h.id]}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="showdown" [ngStyle]="{right: position.pointer}"></div>
                  <div class="message_container">
                    <div>
                      <div class="message_grid"
                        [ngStyle]="{'max-width': position.overflow ? position.overflowwidth : '', 'overflow-x': position.overflow ? 'auto' : 'visible'}">
                        <table>
                          <thead>
                            <tr>
                              <th *ngFor="let h of moreDetailsHeaders">{{h.name}}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td *ngFor="let h of moreDetailsHeaders">{{i[h.id]}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td>{{i['recReason']}}</td>
          </tr>
        </tbody>
        <tbody *ngIf="recomondations.length == 0"
          [ngStyle]="{'display': recomondations.length == 0 ? 'table-row-group' : 'none'}">
          <tr>
            <td [attr.colspan]="ec2CostHeaders.length + 3">
              <div style="text-align: center;">No Recommendations Found</div>
            </td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="nextToken" style="padding: 15px; display: flex; justify-content: center; align-items: center;">
        <img src="../assets/img/loading_2.svg" alt="loading scans" width="10" style="width: 20px; margin: 10px;">
      </div>
    </div>
  </div>
</div>
<ec2-cost-create-job-element *ngIf="createJobTrigger" (hideModal)="hideCreateJob($event)">
</ec2-cost-create-job-element>